var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "6",
        viewBox: "0 0 12 6",
        fill: "none"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M6.35355 5.49684C6.15829 5.6921 5.84171 5.6921 5.64645 5.49684L1.35 1.20039C1.1567 1.00709 1.1567 0.69369 1.35 0.500391C1.5433 0.307091 1.8567 0.307091 2.05 0.500391L5.64645 4.09684C5.84171 4.2921 6.15829 4.2921 6.35355 4.09684L9.95 0.500391C10.1433 0.307091 10.4567 0.307091 10.65 0.500391C10.8433 0.69369 10.8433 1.00709 10.65 1.20039L6.35355 5.49684Z",
          fill: "#2168BC",
          stroke: "#2168BC",
          "stroke-width": "0.5",
          "stroke-linejoin": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af334b7e", { render: render, staticRenderFns: staticRenderFns })
  }
}